<template>
    <div>
        <div class="content energy" style="padding-bottom: 10px;">
            <p>锦威能源管理系统是专为现代企业设计的智能化能源管理平台，提供从数据采集到决策支持的全流程能源监测管控一体化服务。系统通过先进的数据采集技术、智能分析算法和可视化界面，助力企业实现能源精细化管理，全面提升能源利用效率，降低运营成本，推动绿色可持续发展。
            </p>

            <p class="subtitle">产品优势</p>
            <p><img src="../../../../../assets/img/product/energy/energy_youshi.png"></img></p>
        </div>
        <div>
            <p><img src="../../../../../assets/img/product/energy/energy_jiazhi.png"></img></p>
        </div>
        <div class="content energy" style="background: #F2F6FA;padding-top:10px;">
            <p class="subtitle" style="margin-top: 1em;">核心功能模块</p>

            <el-row v-for="(item,index) in contentList" :key="index" :style="{marginTop:item.top}">
                <el-col :span="14" class="left-content" v-if="item.type=='imgLeft'">
                    <div class="img-container" :style="{width:item.imgWidth}"><img
                            :src="require('../../../../../assets/img/product/energy/energy_'+item.img+'.png')"></img></div>
                </el-col>
                <el-col :span="10" class="left-content" v-else>
                    <h3>{{item.name}}</h3>
                    <ul>
                        <li v-for="(child,childIndex) in item.childList" :key="childIndex">
                            <li-item :content="child"></li-item>
                        </li>
                    </ul>
                </el-col>

                <el-col :span="10" class="right-content" v-if="item.type=='imgLeft'">
                    <h3>{{item.name}}</h3>
                    <ul>
                        <li v-for="(child,childIndex) in item.childList" :key="childIndex">
                            <li-item :content="child"></li-item>
                        </li>
                    </ul>
                </el-col>
                <el-col :span="14" class="right-content" v-else>
                    <div class="img-container" :style="{width:item.imgWidth}"><img
                            :src="require('../../../../../assets/img/product/energy/energy_'+item.img+'.png')"></img></div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import liItem from './liItem.vue';
export default{
    components:{
        liItem
    },
    data(){
        return {
            contentList: [{ top: '6em', name: '能源驾驶舱', childList: ['企业级能源全景视图，一屏掌握全局能源态势', '自定义仪表盘，实时展示关键能源指标', '多维度数据可视化，支持快速决策'], img: 'jiashicang', imgWidth: '85%' },
            { top: '10em', name: '能源流向', childList: ['精准展示能源在企业内部的流动路径与消耗分布', '从源头到终端的全链条能源流分析', '识别能源流失环节，优化能源配置'], img: 'liuxiang', type: 'imgLeft', imgWidth: '90%' },
            { top: '10em', name: '运行监测', childList: ['实时监控电力、水、气、热等能源设备运行状态', '24小时不间断监测，确保设备安全稳定运行', '关键参数异常自动预警，减少非计划停机'], img: 'yunxingjiance', imgWidth: '85%' },
            { top: '10em', name: '能效分析与优化', childList: ['分析负荷率、室外环境参数（温湿度）、设备运行组合、运行参数设定（冷冻水温度、冷却水温度）等对系统整体能效和关键设备能效的影响。识别低效运行时段和工况。', '分析本期、同期、环期、同比、环比、结构占比等能效指标项。支持结合设备运行数据和能源数据分析各设备或系统重要能效指标。'], img: 'nengxiao', type: 'imgLeft', imgWidth: '90%' },
            { top: '10em', name: '异常识别与管理', childList: ['基于AI算法的智能异常检测，精准识别能耗异常', '自动化异常处理流程，提升响应效率', '异常事件追溯与分析，持续优化管理'], img: 'yichangshibie', imgWidth: '85%' },
            { top: '10em', name: '碳排放管理', childList: ['全面核算企业碳排放量，满足双碳要求', '碳排放数据自动采集与计算', '多维度分析碳排放变化趋势，识别减排潜力点'], img: 'tanpaifang', type: 'imgLeft', imgWidth: '90%' },
            { top: '10em', name: '节能增效优化', childList: ['针对传统PID控制中，PID参数难以调试、初始运行过程中误差较大、反馈响应不及时等问题，引入AI能效分析及节能增效计算服务器，实时预测并优化控制系统运行，智能适配当前系统的能耗最不利点，选择适配的冷却水泵优化、冷却塔优化、冷机群组优化、冷冻水泵优化等节能优化措施。'], img: 'jienengzengxiaoyouhua', imgWidth: '85%' },
            { top: '10em', name: '节能分析测算', childList: ['量化分析不同运行工况（如负载率、环境温度、设备状态等）下的系统能效差异，基于能耗数据，计算不同工况（或改造前后）的节能率，验证节能措施的实际效果。'], img: 'jienengfenxicesuan', type: 'imgLeft', imgWidth: '90%' },
            { top: '10em', name: '能源数据分析与预测', childList: ['引入大数据模型分析，基于大数据模型的深度运算与历史规律总结，结合车间环境、生产工单及生产设备启停情况，精准预估未来时段不同生产场景下的能源消耗量。'], img: 'fenxiyuce', imgWidth: '85%' },
            { top: '10em', name: '全流程管理应用', childList: ['能源目标设定与动态追踪', '能源计划编制与执行监控', '能源数据建模与可视化展示', '自动化报表生成与推送'], img: 'quanliucheng', type: 'imgLeft', imgWidth: '90%' },
            { top: '10em', name: '智能化分析与决策支持', childList: ['能源实绩汇总与深度分析', '能源指标体系构建与动态评估', '能源平衡模型与优化建议'], img: 'juecezhichi', imgWidth: '85%' }
            ]
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/product.less';
</style>